import React from "react";
import { css } from "@emotion/react";
import { Attachment } from "../../../../types/common";
import AttachmentMedia from "./AttachmentMedia";

interface PreviewProps {
  attachment: Attachment;
  onRemoveImage: (attachment: Attachment) => void;
}

const Preview: React.FC<PreviewProps> = ({ attachment, onRemoveImage }) => {
  return (
    <div css={styles.container}>
      <AttachmentMedia attachment={attachment} mediaCss={styles.media} />
      <div onClick={() => onRemoveImage(attachment)} css={styles.closeButton}>
        <img src="/icons/x.svg" css={styles.closeIcon} />
      </div>
    </div>
  );
};

const styles = {
  container: css({
    position: "relative",
    flexBasis: "48%",
    height: 120,
    overflow: "hidden",
    marginBottom: 8,
    border: "1px solid #e6e9ef",
    borderRadius: 8,
    backgroundColor: "#f5f7fa",
  }),
  media: css({
    width: "100%",
    height: "100%",
    objectFit: "contain",
    display: "block",
    backgroundColor: "#f5f7fa",
  }),
  closeButton: css({
    width: 22,
    height: 22,
    position: "absolute",
    top: 4,
    right: 4,
    backgroundColor: "#ffffff",
    borderRadius: 10,
    cursor: "pointer",
    transition: "all 200ms ease-out",
    ":hover": {
      transform: "scale(1.1)",
      boxShadow: "0 1px 3px #777",
    },
  }),
  closeIcon: css({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 20,
    height: 20,
  }),
};

export default Preview;
